import { render, staticRenderFns } from "./WriteReviewModal.vue?vue&type=template&id=272cfe7c&"
import script from "./WriteReviewModal.vue?vue&type=script&lang=ts&"
export * from "./WriteReviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports